import type { ApiScope } from './apiScopes';

export type ApiKeySummary = {
  id: string;
  name: string;
  key_prefix: string;
  scopes: ApiScope[];
  created_at: string;
  last_used_at: string | null;
  expires_at: string | null;
  /** Aus dem alten Lead-API-Secret migriert; der Klartext ist nicht bekannt. */
  legacy: boolean;
};

export type ApiKeysOverview = {
  instanceId: string;
  canManage: boolean;
  keys: ApiKeySummary[];
};

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, { credentials: 'include', ...init });
  const data = (await res.json().catch(() => null)) as (T & { error?: string }) | null;
  if (!res.ok) throw new Error(data?.error || 'Anfrage fehlgeschlagen.');
  return data as T;
}

export function fetchApiKeys(): Promise<ApiKeysOverview> {
  return request<ApiKeysOverview>('/api/me/api-keys');
}

export function createApiKey(input: { name: string; scopes: ApiScope[] }): Promise<{ key: ApiKeySummary; secret: string }> {
  return request('/api/me/api-keys', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
}

export function renameApiKey(id: string, name: string): Promise<{ key: ApiKeySummary }> {
  return request(`/api/me/api-keys/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
}

export function revokeApiKey(id: string): Promise<{ ok: true }> {
  return request(`/api/me/api-keys/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
